'use strict';

var $ = require('../internals/export');

var $padStart = require('../internals/string-pad').start;

var WEBKIT_BUG = require('../internals/string-pad-webkit-bug'); // `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart


$({
  target: 'String',
  proto: true,
  forced: WEBKIT_BUG
}, {
  padStart: function padStart(maxLength
  /* , fillString = ' ' */
  ) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});